import React, {useEffect, useState} from 'react'
import SEO from '../components/SEO';
import parse from 'html-react-parser';

import './styles/GiftCards.scss'
import HeaderImage from '../components/HeaderImage';
const GiftCards = ({pageContext}) => {
  const [height, setHeight] = useState(null)

  useEffect(() => {
    const handler = event => {
      if (typeof(event.data) === 'string') {
         const data = JSON.parse(event.data)
         setHeight(data.newHeight + 50)
      }
    }
    window.addEventListener("message", handler)
    return () => window.removeEventListener("message", handler)
  }, [])
  return (
    <div className='giftcards'>
      <h1>{pageContext.data.title}</h1>
      <HeaderImage image={{ mobile: pageContext.data.images.mobile.url, desktop: pageContext.data.images.desktop.url }} alt={pageContext.data.images.mobile.alt}/>
      {parse(pageContext.data.content)}
      <iframe title='Gift Cards' style={{ minHeight: 450, height: height, width: '100%' }} src="https://obee.com.au/tgif/vouchers/gift-voucher" frameBorder="0"></iframe>
      <p>Digital gift cards accepted at all TGI Fridays locations nationwide. All online gift card purchases are protected by 3D Secure. This additional layer of protection means all purchases will be authenticated by your financial organisation to verify your identity.</p>
      <p>For full terms and conditions, see <a href='/terms/'>www.tgifridays.com.au/terms/</a></p>
    </div>
  )
}

export default GiftCards
export const Head = ({pageContext}) => (
  <SEO title={pageContext.data.seo.title} description={pageContext.data.seo.description} ogimage={pageContext.data.seo.ogimage} url={pageContext.data.seo.url}/>
)